import styled, { css } from 'styled-components';
import { crTheme } from '@comicrelief/component-library';
import { CheckboxWrapperBase } from '@/components/common/CheckboxWrapper';

const GiftAidWrapperLabel = styled.label<{ checked?: boolean }>`
  display: block;
  margin-top: 2.2rem;
  padding: 1.5rem;
  border-radius: 1rem;

  background-color: ${crTheme.color('white')};
  color: ${crTheme.color('black')};
  /* creates a simple border that fixes internal content jiggling */
  box-shadow: 0 0 0 1px ${crTheme.color('grey')};

  &:focus-within {
    /* creates a simple border that fixes internal content jiggling */
    box-shadow: 0 0 0 2px ${crTheme.color('blue_donate_interact')};
  }

  ${({ checked }) => checked && css`
    background-color: ${crTheme.color('blue_donate')};
    color: ${crTheme.color('white')};
    &:hover {
      background-color: ${crTheme.color('blue_donate_interact')};
    }
  `}
`;

const GiftAidTextWrapper = styled.div<{ checked?: boolean }>`
  text-align: center;
  color: ${crTheme.color('black')};

  ${({ checked }) => checked && css`
    color: ${crTheme.color('white')};
  `}
`;

const GiftAidText = styled.p<{ checked?: boolean }>`
  display: inline;
  color: ${crTheme.color('black')};

  ${({ checked }) => checked && css`
    color: ${crTheme.color('white')};
  `}
`;

const GiftAidTextBold = styled(GiftAidText)`
  font-weight: 700;
`;

const GiftAidCheckboxWrapper = styled(CheckboxWrapperBase)`
  /* Override default margin */
  margin-top: 1rem;

  /* Add hover styles that reference the parent label */
  ${GiftAidWrapperLabel}:hover & {
    background-color: ${crTheme.color('grey_medium')};
    ${({ checked }) => checked && css`
      background-color: ${crTheme.color('blue_donate_interact')};
    `}
  }
`;

// This is just the visual label next to the square checkbox you see.
// The functional label is the GiftAidWrapperLabel parent.
const StyledLabel = styled.p`
  font-size: 0.75rem;
`;

export {
  GiftAidWrapperLabel,
  GiftAidTextWrapper,
  GiftAidText,
  GiftAidTextBold,
  GiftAidCheckboxWrapper,
  StyledLabel
};
